import { useCallback, useEffect, useState } from 'react';

export const INVOICE_EMAIL_SUCCESS_COOLDOWN_SECONDS = 60;

const getRemainingSeconds = (cooldownUntil) => (
    Math.max(0, Math.ceil(((Number(cooldownUntil) || 0) - Date.now()) / 1000))
);

export const useInvoiceEmailCooldown = (cooldownSeconds = INVOICE_EMAIL_SUCCESS_COOLDOWN_SECONDS) => {
    const [cooldowns, setCooldowns] = useState({});
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const hasActiveCooldown = Object.values(cooldowns).some((cooldownUntil) => (
            getRemainingSeconds(cooldownUntil) > 0
        ));

        if (!hasActiveCooldown) {
            return undefined;
        }

        const intervalId = window.setInterval(() => {
            setNow(Date.now());
        }, 1000);

        return () => window.clearInterval(intervalId);
    }, [cooldowns]);

    useEffect(() => {
        setCooldowns((previousCooldowns) => {
            const activeCooldowns = Object.fromEntries(
                Object.entries(previousCooldowns).filter(([, cooldownUntil]) => (
                    getRemainingSeconds(cooldownUntil) > 0
                ))
            );

            return Object.keys(activeCooldowns).length === Object.keys(previousCooldowns).length
                ? previousCooldowns
                : activeCooldowns;
        });
    }, [now]);

    const startCooldown = useCallback((key = 'default') => {
        const normalizedKey = String(key || 'default');
        setCooldowns((previousCooldowns) => ({
            ...previousCooldowns,
            [normalizedKey]: Date.now() + (cooldownSeconds * 1000),
        }));
        setNow(Date.now());
    }, [cooldownSeconds]);

    const getRemaining = useCallback((key = 'default') => {
        const normalizedKey = String(key || 'default');
        return getRemainingSeconds(cooldowns[normalizedKey]);
    }, [cooldowns, now]);

    return {
        startCooldown,
        getRemaining,
    };
};
